import React, { ReactElement } from 'react';
import { isEmpty } from 'lodash';

import { Vehicule } from 'containers/PreOpeningPage/typings';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import { translate } from 'containers/services/translate';
import { injectIntl, IntlShape } from 'react-intl';

export interface ExpertiseVehiculesProps {
  intl: IntlShape;
  vehicules: Vehicule[];
  children?: ReactElement | ReactElement[];
}

const ExpertiseVehicules: React.FC<ExpertiseVehiculesProps> = (
  props,
): JSX.Element => {
  const { vehicules } = props;

  return (
    <section className="list-container">
      <article className="list-title">
        {!isEmpty(vehicules) && translate(messages.vehicules, props)}
      </article>
      <article className="expertise-items">{props.children}</article>
    </section>
  );
};

export default injectIntl(ExpertiseVehicules);
